import { useState, useEffect } from 'react';
import useDataBean from '../../../core/services/dataBean/useDataBean';
import { _LabourType } from '../../../core/services/dataBean/EntityCatalog';
import { BasicTable, MASK_NUMBER } from '../../theme/Component/BasicTable';
import { Modal } from '../../theme/Component/Modal';
import useModal, { MODAL_md, MODAL_SM } from '../../theme/Component/hooks/useModal';
import { _ProductionResource } from '../../../core/services/dataBean/EntityCatalogVdos';
import { ContractService } from '../../../core/services/ContractService';
import { SelectorProcessTypeConstants } from '../../bpm/config/Componentes/SelectorProcessTypeConstants';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const DocEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const service = new ContractService();
    const [lista, setLista] = useState<any>([]);
    const [id, setID] = useState(null);
    const [IDProcessType, setIDProcessType] = useState<number>(null)
    const modal = useModal("Documento", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [IDProcessType])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);

        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDHiringModalityDocument === selectedId
            );

            if (selectedItem) {
                const document = selectedItem.DataBeanProperties;
                onChange(returnType === "Object" ? document : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


    const getLista = () => {
        let filter: any = {};
        if (IDProcessType > 0) {
            filter.ProcessType = IDProcessType
        }
        service.getHiringModalityDocumentRender(null, null, filter).subscribe(
            (resp: any) => {


                setLista(resp.DataBeanProperties.ObjectValue.DataBeanProperties.List)
                console.log(resp.DataBeanProperties.ObjectValue.DataBeanProperties.List)
            }
        )
    }
    const head = [
        { title: 'ID', property: 'IDHiringModalityDocument', visible: true, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Documento"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-6">
                        <SelectorProcessTypeConstants idSelector={IDProcessType} onChange={(e) => { setIDProcessType(e) }} />
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDHiringModalityDocument); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}